import {
	AddPrivacyIcon,
	BlockColdIcon,
	BlockHeatIcon,
	BlockLightIcon,
	BlockNoiseIcon,
	BlockPollutantsIcon,
	BlockUvIcon,
	EnergyEfficiencyIcon,
	GovtIcon,
	HistoricWindowsIcon,
	HotelIcon,
	LargeProjectIcon,
	OfficeIcon,
	PreventCondensationIcon,
	SaveMoneyIcon,
	SpecialtyShapesIcon,
} from './images/solution-icons.svelte';

import AddPrivacyGraphic from './images/graphic_add-privacy.svg';
import BlockDraftsGraphic from './images/graphic_block-drafts.svg?inline';
import BlockHeatGraphic from './images/graphic_block-heat.svg';
import BlockLightGraphic from './images/graphic_block-light.svg';
import BlockNoiseGraphic from './images/graphic_block-noise.svg';
import BlockUvGraphic from './images/graphic_block-uv.svg';

const AddPrivacySolution = {
	src: AddPrivacyIcon,
	graphic: AddPrivacyGraphic,
	title: 'Add Privacy',
	href: '/solutions/privacy-window-coverings',
};

const BlockColdSolution = {
	src: BlockColdIcon,
	graphic: BlockDraftsGraphic,
	title: 'Block Cold',
	href: '/solutions/insulating-drafty-windows',
};

const BlockHeatSolution = {
	src: BlockHeatIcon,
	graphic: BlockHeatGraphic,
	title: 'Block Heat',
	href: '/solutions/insulate-windows-from-heat',
};

const BlockNoiseSolution = {
	src: BlockNoiseIcon,
	graphic: BlockNoiseGraphic,
	title: 'Block Noise',
	href: '/solutions/window-noise-reduction',
};

const BlockPollutantsSolution = {
	src: BlockPollutantsIcon,
	graphic: null,
	title: 'Block Pollutants',
	href: '/solutions/block-pollen-and-pollutants',
};

const BlockUVSolution = {
	src: BlockUvIcon,
	graphic: BlockUvGraphic,
	title: 'Block UV',
	href: '/solutions/block-damaging-uv-light',
};

const BlockLightSolution = {
	src: BlockLightIcon,
	graphic: BlockLightGraphic,
	title: 'Block Light',
	href: '/solutions/blackout-window-solutions',
};

const EnergyEfficiencySolution = {
	src: EnergyEfficiencyIcon,
	graphic: null,
	title: 'Energy Efficiency',
	href: '/solutions/reduce-energy-waste',
};

const HistoricWindowsSolution = {
	src: HistoricWindowsIcon,
	graphic: null,
	title: 'Historic Windows',
	href: '/solutions/preserve-historic-windows',
};

const PreventCondensationSolution = {
	src: PreventCondensationIcon,
	graphic: null,
	title: 'Prevent Condensation',
	href: '/solutions/prevent-window-condensation',
};

const SaveMoneySolution = {
	src: SaveMoneyIcon,
	graphic: null,
	title: 'Save Money',
	href: '/solutions/lower-energy-bills',
};

const SpecialtyShapesSolution = {
	src: SpecialtyShapesIcon,
	graphic: null,
	title: 'Specialty Shapes',
	href: '/solutions/odd-shaped-window-inserts',
};

const HotelSolution = {
	src: HotelIcon,
	graphic: null,
	title: 'HOTEL',
	href: '/commercial-storm-windows/hotel-soundproofing',
};

const LargeProjectSolution = {
	src: LargeProjectIcon,
	graphic: null,
	title: 'LARGE PROJECTS',
	href: '/solutions/commercial-window-inserts',
};

const OfficeSolution = {
	src: OfficeIcon,
	graphic: null,
	title: 'OFFICE',
	href: '/commercial-storm-windows/office-soundproofing',
};

const GovernmentSolution = {
	src: GovtIcon,
	graphic: null,
	title: 'GOVT',
	href: '/resources/case-studies/insulating-government-buildings',
};

export {
	AddPrivacySolution,
	BlockColdSolution,
	BlockHeatSolution,
	BlockLightSolution,
	BlockNoiseSolution,
	BlockPollutantsSolution,
	BlockUVSolution,
	EnergyEfficiencySolution,
	GovernmentSolution,
	HistoricWindowsSolution,
	HotelSolution,
	LargeProjectSolution,
	OfficeSolution,
	PreventCondensationSolution,
	SaveMoneySolution,
	SpecialtyShapesSolution,
};
